// Pure maintenance-mode helpers (dependency-free CommonJS so they unit-test with `node --test`
// and default-import into the router). v1 reads the static public/maintenance.json; a DB-backed
// flag can later be merged into `config` before these run, with no change to this logic.
//
// config shape: { enabled: boolean, message?: string, bypassToken?: string }

function isMaintenanceOn(config) {
    return !!(config && config.enabled === true);
}

// Non-secret convenience bypass so staff can still reach the site during maintenance. Matches when
// the config defines a bypassToken and the supplied token equals it (visit ?mbypass=<token> once).
function hasBypass(config, token) {
    const expected = config && config.bypassToken;
    return !!expected && token != null && token !== '' && String(token) === String(expected);
}

// Where the router should send the user:
//   '/maintenance' -> show the maintenance screen (maintenance active, not already there, no bypass)
//   '/'            -> leave the maintenance screen (maintenance cleared while parked on it)
//   null           -> no redirect
function maintenanceTarget(options) {
    const opts = options || {};
    const onMaintenanceRoute = opts.routeName === 'Maintenance';
    const active = isMaintenanceOn(opts.config) && !hasBypass(opts.config, opts.bypassToken);
    if (active && !onMaintenanceRoute) return '/maintenance';
    if (!active && onMaintenanceRoute) return '/';
    return null;
}

module.exports = { isMaintenanceOn, hasBypass, maintenanceTarget };
